import React, { useEffect, useState } from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Sidebar from "../../Components/Sidebar/Sidebar";
import ConfirmationModal from "../Modals/ConfirmationModal";
import "./cleanerpayment.css";
import Dropdown from "../Dropdown/Dropdown";
import { useLocation, useNavigate } from "react-router-dom";
import { servicePost } from "../../helper/api";
import moment from "moment";
import CommonModal from "../Modals/CommonModal";

const CleanerPaymentView = () => {
  const [cleanerPaymentData, setCleanerPaymentData] = useState();
  const [modalShow, setModalShow] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState();
  const [showCommanModal, setShowCommanModal] = useState(false);
  const navigate = useNavigate();

  // get AuthToken from localStorage
  const authToken = localStorage.getItem("token");
  const notification = "";

  const location = useLocation();
  const data = location?.state?.data;

  const getCleanerPaymetData = async () => {
    try {
      const gatCleanerPaymentRes = await servicePost(
        "adminbooking/getCleanerPayOrderData",
        {
          contractorPayoutId: data?.contractorPayoutId,
        },
        notification,
        authToken
      );

      setCleanerPaymentData(gatCleanerPaymentRes.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    getCleanerPaymetData();
  }, [data?.contractorPayoutId]);

  const handleDropdownChange = async (status) => {
    setSelectedStatus(status);
    try {
      const updateApplication = await servicePost(
        "adminbooking/updateCleanerPayOrderData",
        {
          contractorPayoutId: data?.contractorPayoutId,
          status: status,
        },
        notification,
        authToken
      );
      console.log("updateApplication", updateApplication);
      if (updateApplication.message == "SUCCESS") {
        setShowCommanModal(true);
        setTimeout(() => {
          setShowCommanModal(false);
        }, 2000);
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const StatusDropdown = [
    {
      name: "Pending",
    },
    {
      name: "Processing",
    },

    {
      name: "Completed",
    },
  ];

  const goToBack = () => {
    navigate("/cleaner-payment");
  };

  //
  const goToTxDetail = (data) => {
    navigate("/transation-detail", {
      state: { bookingId: data.bookingId },
    });
  };

  // Go To Contractor Account
  const goToContractorAccDetail = () => {
    navigate("/contractoraccount-detail", {
      state: { AccountId: cleanerPaymentData[0]?.contractorid },
    });
  };

  return (
    <>
      <CommonModal
        show={showCommanModal}
        onHide={() => setShowCommanModal(false)}
        type="Status Updated Successfully"
      />
      <Navbar />
      <Sidebar />
      <div className="trasfer-histroy-wrapper transfer-admin-history-wrap">
        <div className="container">
          <div className="cleaner-payment-detail-header">
            <div className="cleaner-payment-detail-left">
              <div className="cleaner-payment-tx-wrap">
                <img
                  onClick={goToBack}
                  src="./images/icons/back-arrow.png"
                  alt="icon"
                />
                <h3>
                  Transaction ID : <span> #{data?.contractorPayoutId} </span>
                </h3>
              </div>
              <h4>
                Week of:{" "}
                <span>
                  {" "}
                  {moment(data.fromDate).format("DD MMM")} -{" "}
                  {moment(data.toDate).format("DD MMM, YYYY")}
                </span>
              </h4>
              <p>
                Cleaner:{" "}
                <span
                  className="active-tx-id"
                  onClick={() => goToContractorAccDetail()}
                >
                  {data?.contractorName}{" "}
                </span>
              </p>
            </div>

            <div className="cleaner-payment-detail-right filter-select-wraper">
              <Dropdown
                onTypeChange={handleDropdownChange}
                label="Status"
                data={StatusDropdown}
              />
            </div>
          </div>

          <div className="tranfer-history-dropdown-wrapper table-responsive">
            <table id="transfer" className="table table-striped">
              <thead>
                <tr>
                  <th> Transaction Id </th>
                  <th> items </th>
                  <th> Date </th>
                  <th> Client </th>
                  <th> Amount </th>
                  <th> Type </th>
                </tr>
              </thead>
              <tbody>
                {cleanerPaymentData?.length > 0 ? (
                  cleanerPaymentData.map((data, index) => (
                    <tr key={index}>
                      <td className="table-active-td">
                        {" "}
                        <span
                          className="active-tx-id"
                          onClick={() => goToTxDetail(data)}
                        >
                          #{data.bookingId}
                        </span>
                      </td>
                      <td>{data?.cartItems?.length} Items</td>
                      <td>{moment(data.createdAt).format("DD MMM YYYY")} </td>
                      <td>{data.clientName}</td>
                      <td>${Number(data.cleanerCommision).toFixed(2)}</td>
                      <td>
                        <div className="table-status-icon">
                          {data.serviceType == "Residential" ? (
                            <img
                              className="type-icon-wrap"
                              src="./images/icons/type-icon.png"
                              alt="icon"
                            />
                          ) : (
                            <img
                              className="type-icon-wrap"
                              src="./images/icons/type-commercial.png"
                              alt="icon"
                            />
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="9">No Data Found</td>
                  </tr>
                )}
              </tbody>
            </table>

            <div className="cleaner-payout-wrapper">
              <div className="cleaner-payout-wrap">
                <h3> cleaner payout </h3>
                <p> ${Number(data?.cleanerCommisionWeekly).toFixed(2)} </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CleanerPaymentView;
